import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "I made the right choice by choosing the Ideal Body Fit and by choosing the right plan and program I already achieved my ideal body!",
    name: 'MATHEW HENDRICKSON',
    status : 'ENTREPRENEUR'
  },
  {
    image: image2,
    review: 'I am thrilled with the incredible results I have achieved since joining Ideal Body Fit. It has been a transformative experience for me! ',
    name: 'JOHN KEVIN',
    status: 'COACH'
  },
  {
    image : image3,
    review:' Thanks to Ideal Body Fit ive seen significant improvement in my overall body fitness i feel happy and motivated!',
    name: 'CLEMENTINE',
    status: "CUSTOMER"
  }
];
